export const version = "contracts/5.7.0";
//# sourceMappingURL=_version.js.map